import types from '@constants/action-types';
import { COUNTRIES } from '@constants/countries';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  results: [],
  selected: [],
  isFetching: false,
  hasFetched: false,
  error: null,
};

export default reducerFactory(initialState, {
  [types.GET_VAT_NUMBERS_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
    isFetching: true,
    hasFetched: false,
    results: [],
  }),
  [types.GET_VAT_NUMBERS_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    isFetching: false,
    hasFetched: true,
    ...response.vatNumbers,
  }),
  [types.GET_VAT_NUMBERS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    isFetching: false,
    hasFetched: false,
    error: response.error,
  }),
  [types.REMOVE_VAT_NUMBERS]: state => ({
    ...state,
    results: [],
  }),
  [types.REMOVE_ALL_FILING_TYPES]: state => ({
    ...state,
    selected: [],
  }),
  [types.SET_BANKING_DETAILS_SUCCESS]: (state, { payload }) => ({
    ...state,
    results: state.results.map(result =>
      result.country.iso === COUNTRIES.PL ? { ...result, ...payload } : result
    ),
  }),
});
